import { jsx as _jsx } from "react/jsx-runtime";
import { useFarbwelt } from "@/hooks/useFarbwelt";
import { Box } from "@gemini/core";
import { Avatar } from "@gemini/ui";
import { BuildingFilledIcon } from "@gemini/icons";
export const FarbweltLogo = ({ size = "64", testId, position = "absolute", stickyBannerLogo = false, }) => {
    const FallbackIcon = () => _jsx(BuildingFilledIcon, {});
    const { logo, providerName, bgColor } = useFarbwelt();
    const label = providerName || "Avatar";
    const logoContainerStyles = stickyBannerLogo
        ? {
            backgroundColor: (logo
                ? "color.surface.default.default"
                : "color.surface.light.default"),
            borderRadius: "radius.8",
        }
        : {
            backgroundColor: (bgColor
                ? bgColor
                : "color.surface.light.default"),
        };
    return logo ? (_jsx(Box, Object.assign({ zIndex: "zIndex.1", position: position }, logoContainerStyles, { testId: testId, children: stickyBannerLogo ? (_jsx(Avatar, { imageUrl: logo.src, imageFit: "contain", label: label, size: size, testId: `${testId}-avatar` })) : (_jsx(Avatar, { imageUrl: logo.src, imageFit: "contain", label: label, testId: `${testId}-avatar`, type: "rectangle-fluid", maxSize: "120x40" })) }))) : stickyBannerLogo ? (_jsx(Box, { zIndex: "zIndex.1", position: position, backgroundColor: logo ? "color.surface.default.default" : "color.surface.light.default", borderRadius: "radius.8", testId: testId, cursor: "pointer", children: _jsx(Avatar, { icon: FallbackIcon, label: label, size: size, testId: `${testId}-fallbackIcon` }) })) : null;
};
